import type {Editor} from "@tiptap/core";
import {NodeSelection} from "@tiptap/pm/state";
import type {SelectedPrintoutBlock, SelectedPrintoutNode} from "../useSelectedPrintoutBlock";

export interface PrintoutBlockSettingsProps {
    block: SelectedPrintoutBlock;
    disabled?: boolean;
    editor: Editor;
}

// Address by position so panel focus and the edited node survive each transaction.
export const updateSelectedPrintoutBlockAttributes = <T extends object>(
    editor: Editor,
    block: SelectedPrintoutNode,
    attrs: T,
) => {
    if (editor.isDestroyed) return;

    editor
        .chain()
        .command(({tr}) => {
            const nodeWasSelected = tr.selection instanceof NodeSelection && tr.selection.from === block.pos;

            tr.setNodeMarkup(block.pos, undefined, {...block.node.attrs, ...attrs});

            // Preserve a NodeSelection so the settings panel stays open.
            if (nodeWasSelected) tr.setSelection(NodeSelection.create(tr.doc, block.pos));

            return true;
        })
        .run();
};
